import useRequest from "@/lib/request/useRequest";
import { FieldWithEnrollment } from "@/types/field";
import {
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    Input,
} from "@heroui/react";
import { useCallback, useState } from "react";

function RefundForm({
    onClose,
    enrollment,
}: {
    onClose: () => void;
    enrollment: FieldWithEnrollment;
}) {
    const { useMutateRequest } = useRequest();
    const refundMutation = useMutateRequest({
        errorMessage: "Failed to refund enrollment",
        successMessage: "Successfully refunded enrollment",
    });
    const [refundAmount, setRefundAmount] = useState("");

    const onRefund = useCallback(() => {
        if (!enrollment.active_enrollment) {
            return;
        }
        const payload: Record<string, number> = {};
        if (refundAmount !== "") {
            payload["retail_refund_price_per_acre"] = Number(refundAmount);
        }
        refundMutation.mutate(
            {
                url: `field_enrollments/${enrollment.active_enrollment.id}/refund/`,
                method: "post",
                data: payload,
            },
            {
                onSuccess: () => {
                    onClose();
                },
            },
        );
    }, [enrollment, refundAmount, refundMutation, onClose]);

    return (
        <Modal isOpen onClose={onClose}>
            <ModalContent>
                <ModalHeader>
                    Refund Enrollment - {enrollment.name} (
                    {enrollment.grower.name})
                </ModalHeader>
                <ModalBody>
                    <Input
                        type="number"
                        size="sm"
                        label="Refund Amount (Not Required)"
                        labelPlacement="outside"
                        value={refundAmount.toString()}
                        onChange={(e) => setRefundAmount(e.target.value)}
                        placeholder=" "
                    />
                    <div className="text-xs italic">
                        This is the total per acre amount refunded to the CSPs
                        account balance.
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button onPress={onClose}>Cancel</Button>
                    <Button color="primary" onPress={onRefund}>
                        Refund
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export default RefundForm;
